import { REDUCER_UPDATE_QUALITY } from './actionTypes';
import ReducerRegistry from "../base/redux/ReducerRegistry";
const DEFAULT_STATE = {
    qualityLevel: 'high',
};
/**
 * Listen for actions that mutate the prejoin state.
 */
ReducerRegistry.register('features/quality-control', (state = DEFAULT_STATE, action) => {
    switch (action.type) {
        case REDUCER_UPDATE_QUALITY:
            return {
                ...state,
                qualityLevel: action.value
            };
        default:
            return state;
    }
});
